<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="我的展会" />
		<el-button class="add-btn" @click="handleAdd">发布</el-button>
		<el-table :data="tableData" border>
			<el-table-column fixed prop="title" label="展会名称" />
			<!-- <el-table-column  label="展会起止时间" >
				<template slot-scope="scope">
					{{scope.row.start_time}} ~{{scope.row.end_time}}
				</template>
			</el-table-column>
			<el-table-column width="" prop="address" label="展会地址" /> -->
			<el-table-column width="120" prop="viewnum" label="浏览次数" />
			<el-table-column width="120" prop="add_num" label="报名参展数" />
			<el-table-column width="120" prop="see_num" label="观展人数" />
			<el-table-column width="280" label="操作">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" type="text" size="small">展会设置</el-button>
					<el-button @click="handlecanzhan(scope.row)" type="text" size="small">展商管理</el-button> 
					<!-- <el-button type="text" size="small" @click="handlecanzhan(scope.row)">参展</el-button> -->
					<el-button type="text" size="small" @click="handleguanzhan(scope.row)">观展</el-button>
					<el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
			@current-change="currentChange" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				p: 1,
				total: 0,
				a:1
			}
		},
		created() {
			this.getData()
		},
		methods: {
			handlecanzhan(row){
				this.$router.push({path:'/exhibitor',query:{id:row.id}});
			},
			handleguanzhan(row){
				this.$router.push(`/zhgl/viewing?id=${row.id}`)
			},
			getData() {
				this.$axios.post('Exhibition-Admin-getExhibitionShopList', {
					user_id:this.$store.state.USER_ID,
				}).then(data => {
					if(data != null){
						this.tableData = data
					}
				})
			},
			handleEdit(row) {
				this.$router.push({path:'/expo',query:{id:row.id}});
			},
			handleDelete(row){
				//删除
				let a  = {
					user_id:this.$store.state.USER_ID,
					exhibition_id:row.id,
					state:3
				}
				this.$axios.post('Exhibition-Admin-addSaveExhibitionShopInfo',a).then(data => {
					this.$message.success('删除成功')
					this.getData()
				})
				
			},
			currentChange(page) {
				this.p = page
				this.getData()
			},
			handleAdd() {
				this.$router.push('/expo')
			}
		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
</style>
